import { AutoAwesome } from '@mui/icons-material';
import { Chip, Stack, styled, Typography } from '@mui/material';
import { fontFamily } from '@/@mui/tokens/font-family';
import { fontWeights } from '@/@mui/tokens/font-weights';

const GRADIENT = 'linear-gradient(90deg, #FF2BD1 0%, #00AAED 100%)';

const StyledChip = styled(Chip)(() => ({
  borderRadius: 4,
  background: GRADIENT,
}));

export const NewChip = () => (
  <StyledChip
    size="small"
    label={
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography
          variant="body2"
          fontFamily={fontFamily.fontFamilyCarbona}
          fontWeight={fontWeights.fontWeightBold}
          color="white"
          mt="1px" // sem isso fica desalinhado com o ícone
        >
          NOVO
        </Typography>
        <AutoAwesome sx={{ color: 'white', fontSize: 16 }} />
      </Stack>
    }
  />
);
